var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResumeQuestionsForm',{attrs:{"resumeParams":_vm.resumeParams,"recruitmentResumeQuestions":_vm.recruitmentResumeQuestions,"resumeQuestionsLocale":_vm.resumeQuestionsLocale}})}
var staticRenderFns = []

export { render, staticRenderFns }